"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.root = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ = require("../../..");

var _fourOperations = require("../base/four-operations");

var _parser = require("../base/parser");

var _utils = require("../base/utils");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var root = function root() {
  return (0, _.chain)(statements, (0, _.optional)(';'))(function (ast) {
    return ast[0];
  });
};

exports.root = root;

var statements = function statements() {
  return (0, _.chain)(statement, (0, _.many)((0, _.chain)(';', statement)(function (ast) {
    return ast[1];
  })))(_utils.flattenAll);
};

var statement = function statement() {
  return (0, _.chain)([selectStatement, createTableStatement, insertStatement, createViewStatement, setStatement, createIndexStatement, createFunctionStatement, updateStatement])(function (ast) {
    return ast[0];
  });
};

var selectStatement = function selectStatement() {
  return (0, _.chain)('select', selectList, (0, _.optional)(fromClause), (0, _.optional)(orderByClause), (0, _.optional)(limitClause), (0, _.optional)(union, selectStatement))(function (ast) {
    var result = {
      type: 'statement',
      variant: 'select',
      result: ast[1],
      from: ast[2]
    };

    if (ast[5]) {
      result.union = ast[5];
    }

    return result;
  });
};

var union = function union() {
  return (0, _.chain)('union', ['all', 'distinct'])();
};

var fromClause = function fromClause() {
  return (0, _.chain)('from', tableSources, (0, _.optional)(whereStatement), (0, _.optional)(groupByStatement), (0, _.optional)(havingStatement))(function (ast) {
    return {
      sources: ast[1],
      where: ast[2],
      group: ast[3],
      having: ast[4]
    };
  });
};

var selectList = function selectList() {
  return (0, _.chain)(selectField, (0, _.many)(selectListTail))(_utils.flattenAll);
};

var selectListTail = function selectListTail() {
  return (0, _.chain)(',', selectField)(function (ast) {
    return ast[1];
  });
};

var selectField = function selectField() {
  return (0, _.chain)([(0, _.chain)((0, _.many)('not'), [(0, _.chain)(field, (0, _.optional)(overClause))(function (ast) {
    return ast[0];
  }), (0, _.chain)('(', field, ')')()], (0, _.optional)(alias))(function (ast) {
    return {
      type: 'identifier',
      variant: 'column',
      name: ast[1],
      alias: ast[2]
    };
  }), '*'])(function (ast) {
    return ast[0];
  });
};

var whereStatement = function whereStatement() {
  return (0, _.chain)('where', expression)(function (ast) {
    return ast[1];
  });
};

var fieldList = function fieldList() {
  return (0, _.chain)(columnField, (0, _.many)(',', columnField))();
};

var tableSources = function tableSources() {
  return (0, _.chain)(tableSource, (0, _.many)((0, _.chain)(',', tableSource)(function (ast) {
    return ast[1];
  })))(_utils.flattenAll);
};

var tableSource = function tableSource() {
  return (0, _.chain)(tableSourceItem, (0, _.many)(joinPart))(function (ast) {
    return {
      source: ast[0],
      joins: ast[1],
      type: 'statement',
      variant: 'tableSource'
    };
  });
};

var tableSourceItem = function tableSourceItem() {
  return (0, _.chain)([(0, _.chain)(tableName, (0, _.optional)(alias))(function (ast) {
    return {
      type: 'identifier',
      variant: 'table',
      name: ast[0],
      alias: ast[1]
    };
  }), (0, _.chain)([selectStatement, (0, _.chain)('(', selectStatement, ')')(function (ast) {
    return ast[1];
  })], alias)(function (ast) {
    return _objectSpread({}, ast[0], {
      alias: ast[1]
    });
  })])(function (ast) {
    return ast[0];
  });
};

var joinPart = function joinPart() {
  return (0, _.chain)(['join', 'straight_join', (0, _.chain)(['inner', 'cross', 'full'], 'join')(), (0, _.chain)(['left', 'right'], (0, _.optional)('outer'), 'join')(), (0, _.chain)('natural', (0, _.optional)(['left', 'right'], (0, _.optional)('outer')), 'join')()], tableSourceItem, (0, _.optional)('on', expression))(function (ast) {
    return {
      type: 'statement',
      variant: 'join',
      join: ast[1],
      conditions: ast[2]
    };
  });
};

var alias = function alias() {
  return (0, _.chain)([(0, _.chain)('as', _parser.stringOrWord)(function (ast) {
    return ast[1];
  }), _parser.stringOrWord])(function (ast) {
    return ast[0];
  });
};

var createTableStatement = function createTableStatement() {
  return (0, _.chain)('create', 'table', _parser.stringOrWord, '(', tableOptions, ')', (0, _.optional)(withStatement))();
};

var withStatement = function withStatement() {
  return (0, _.chain)('with', '(', withStatements, ')')();
};

var withStatements = function withStatements() {
  return (0, _.chain)(withStatementsTail, (0, _.many)(',', withStatementsTail))();
};

var withStatementsTail = function withStatementsTail() {
  return (0, _.chain)(_parser.wordSym, '=', _parser.stringSym)();
};

var tableOptions = function tableOptions() {
  return (0, _.chain)(tableOption, (0, _.many)(',', tableOption))();
};

var tableOption = function tableOption() {
  return (0, _.chain)(_parser.stringOrWord, _parser.dataType)();
};

var primaryKeyList = function primaryKeyList() {
  return (0, _.chain)(_parser.wordSym, (0, _.optional)(',', primaryKeyList))();
};

var tableName = function tableName() {
  return (0, _.chain)([(0, _.chain)(_parser.stringOrWord)(), (0, _.chain)(_parser.stringOrWord, '.', _parser.stringOrWord)(function (ast) {
    return [ast[0], ast[2]];
  })])(function (ast) {
    if (ast[0].length === 1) {
      return (0, _utils.createTableName)({
        namespace: null,
        tableName: ast[0][0]
      });
    }

    if (ast[0].length === 2) {
      return (0, _utils.createTableName)({
        namespace: ast[0][0],
        tableName: ast[0][1]
      });
    }
  });
};

var havingStatement = function havingStatement() {
  return (0, _.chain)('having', expression)();
};

var createViewStatement = function createViewStatement() {
  return (0, _.chain)('create', 'view', _parser.wordSym, 'as', selectStatement)();
};

var insertStatement = function insertStatement() {
  return (0, _.chain)('insert', (0, _.optional)('ignore'), 'into', tableName, (0, _.optional)(selectFieldsInfo), [selectStatement])(function (ast) {
    return {
      type: 'statement',
      variant: 'insert',
      into: {
        type: 'indentifier',
        variant: 'table',
        name: ast[3]
      },
      result: ast[5]
    };
  });
};

var selectFieldsInfo = function selectFieldsInfo() {
  return (0, _.chain)('(', selectFields, ')')();
};

var selectFields = function selectFields() {
  return (0, _.chain)(_parser.wordSym, (0, _.many)(',', _parser.wordSym))();
};

var groupByStatement = function groupByStatement() {
  return (0, _.chain)('group', 'by', fieldList)();
};

var orderByClause = function orderByClause() {
  return (0, _.chain)('order', 'by', orderByExpressionList)();
};

var orderByExpressionList = function orderByExpressionList() {
  return (0, _.chain)(orderByExpression, (0, _.many)(',', orderByExpression))();
};

var orderByExpression = function orderByExpression() {
  return (0, _.chain)(expression, (0, _.optional)(['asc', 'desc']))();
};

var partitionByClause = function partitionByClause() {
  return (0, _.chain)([_parser.wordSym, (0, _.chain)('partition', 'by', expression)()])(function (ast) {
    return ast;
  });
};

var overClause = function overClause() {
  return (0, _.chain)('over', '(', overTailExpression, ')')();
};

var overTailExpression = function overTailExpression() {
  return (0, _.chain)([partitionByClause, (0, _.chain)(field, orderByClause)()], (0, _.many)(',', overTailExpression))();
};

var limitClause = function limitClause() {
  return (0, _.chain)('limit', [_parser.numberSym, (0, _.chain)(_parser.numberSym, ',', _parser.numberSym)(), (0, _.chain)(_parser.numberSym, 'offset', _parser.numberSym)()])();
};

var functionChain = function functionChain() {
  return (0, _.chain)([castFunction, normalFunction, ifFunction])(function (ast) {
    return ast[0];
  });
};

var ifFunction = function ifFunction() {
  return (0, _.chain)('if', '(', predicate, ',', field, ',', field, ')')(function (ast) {
    return {
      type: 'function',
      name: 'if',
      args: [ast[2], ast[4], ast[6]]
    };
  });
};

var castFunction = function castFunction() {
  return (0, _.chain)('cast', '(', field, 'as', _parser.dataType, ')')(function (ast) {
    return {
      type: 'function',
      name: 'cast',
      args: [ast[2], ast[4]]
    };
  });
};

var normalFunction = function normalFunction() {
  return (0, _.chain)(_parser.wordSym, '(', (0, _.optional)(functionFields), ')', (0, _.optional)('filter', '(', whereStatement, ')'))(function (ast) {
    return {
      type: 'function',
      name: ast[0],
      args: ast[2]
    };
  });
};

var functionFields = function functionFields() {
  return (0, _.chain)(functionFieldItem, (0, _.many)(',', functionFieldItem))();
};

var functionFieldItem = function functionFieldItem() {
  return (0, _.chain)((0, _.many)(_parser.selectSpec), [columnField, caseStatement])(function (ast) {
    return ast;
  });
};

var caseStatement = function caseStatement() {
  return (0, _.chain)('case', (0, _.plus)(caseAlternative), (0, _.optional)('else', [columnField, 'null']), ['end', (0, _.chain)('end', 'as', _parser.wordSym)()])();
};

var caseAlternative = function caseAlternative() {
  return (0, _.chain)('when', expression, 'then', fieldItem)();
};

var setStatement = function setStatement() {
  return (0, _.chain)('set', variableAssignments)();
};

var variableAssignments = function variableAssignments() {
  return (0, _.chain)(variableAssignment, (0, _.many)(',', variableAssignment))();
};

var variableAssignment = function variableAssignment() {
  return (0, _.chain)(variableLeftValue, '=', ['true', 'false', _parser.stringSym, _parser.numberSym])();
};

var variableLeftValue = function variableLeftValue() {
  return (0, _.chain)(_parser.wordSym, (0, _.many)('.', _parser.wordSym))();
};

var expression = function expression() {
  return (0, _.chain)(expressionHead, (0, _.many)(_parser.logicalOperator, expression))(_utils.flattenAll);
};

var expressionHead = function expressionHead() {
  return (0, _.chain)([(0, _.chain)('(', expression, ')')(), (0, _.chain)(_parser.notOperator, expression)(), (0, _.chain)(booleanPrimary)], (0, _.optional)((0, _.chain)('is', (0, _.optional)('not'), ['true', 'false', 'unknown'])()))(function (ast) {
    return ast[0];
  });
};

var booleanPrimary = function booleanPrimary() {
  return (0, _.chain)(predicate, (0, _.many)(['isnull', (0, _.chain)([(0, _.chain)('is', 'not')(), 'is', 'not'], ['null', columnField])()]))(_utils.flattenAll);
};

var predicate = function predicate() {
  return (0, _.chain)([(0, _.chain)(columnField, predicateAddonComparison)(), (0, _.chain)('(', predicate, ')', predicateAddonComparison)()])();
};

var predicateAddonComparison = function predicateAddonComparison() {
  return (0, _.chain)((0, _.optional)([(0, _.chain)(_parser.comparisonOperator, columnField)(), (0, _.chain)('sounds', 'like', columnField)(), isOrNotExpression]), (0, _.optional)(['or', predicate]))();
};

var columnField = function columnField() {
  return (0, _.chain)(field)(function (ast) {
    return {
      type: 'identifier',
      variant: 'column',
      name: ast[0]
    };
  });
};

var isOrNotExpression = function isOrNotExpression() {
  return (0, _.chain)((0, _.optional)('is'), (0, _.optional)('not'), [(0, _.chain)('in', '(', [selectStatement, fieldList], ')')(), (0, _.chain)('between', field, 'and', predicate)(), (0, _.chain)('like', field, (0, _.optional)('escape', field))(), (0, _.chain)('regexp', field)(), 'null'])();
};

var fieldItem = function fieldItem() {
  return (0, _.chain)(fieldItemDetail, (0, _.many)(_parser.normalOperator, fieldItemDetail))(function (ast) {
    if (!ast[1]) {
      return ast[0];
    }

    return [ast[0], ast[1]];
  });
};

var fieldItemDetail = function fieldItemDetail() {
  return (0, _.chain)([functionChain, caseStatement, (0, _.chain)(_parser.stringOrWordOrNumber, (0, _.optional)([(0, _.chain)('.', '*')(function (ast) {
    return {
      type: 'identifier',
      variant: 'groupAll'
    };
  }), (0, _.chain)(':', normalFunction)(), dotStringOrWordOrNumber]))(function (ast) {
    if (!ast[1]) {
      return ast[0];
    }

    return _objectSpread({}, ast[1], {
      groupName: ast[0]
    });
  }), '*'])(function (ast) {
    return ast[0];
  });
};

var dotStringOrWordOrNumber = function dotStringOrWordOrNumber() {
  return (0, _.chain)('.', [_parser.stringSym, _parser.numberSym, (0, _.chain)(_parser.wordSym)(function (ast) {
    return {
      type: 'identifier',
      variant: 'columnAfterGroup',
      name: ast[0]
    };
  })])(function (ast) {
    return ast[1];
  });
};

var field = function field() {
  return (0, _fourOperations.createFourOperations)(fieldItem)();
};

var createIndexStatement = function createIndexStatement() {
  return (0, _.chain)('create', 'index', indexItem, onStatement, whereStatement)();
};

var indexItem = function indexItem() {
  return (0, _.chain)(_parser.stringSym, (0, _.many)('.', _parser.stringSym))();
};

var onStatement = function onStatement() {
  return (0, _.chain)('ON', _parser.stringSym, '(', fieldForIndexList, ')')();
};

var fieldForIndex = function fieldForIndex() {
  return (0, _.chain)(_parser.stringSym, (0, _.optional)(['ASC', 'DESC']))();
};

var fieldForIndexList = function fieldForIndexList() {
  return (0, _.chain)(fieldForIndex, (0, _.many)(',', fieldForIndex))();
};

var createFunctionStatement = function createFunctionStatement() {
  return (0, _.chain)('create', 'function', _parser.wordSym, 'as', _parser.stringSym)();
};

var updateStatement = function updateStatement() {
  return (0, _.chain)('UPDATE', tableSourceItem, 'SET', _parser.setValueList, (0, _.optional)(whereStatement))();
};